import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useQueryClient } from 'react-query'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import CancelIcon from '@material-ui/icons/Cancel'
import Container from '@material-ui/core/Container'
import { Button, Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Chip from '@material-ui/core/Chip'
import moment from 'moment'
import { Helmet } from 'react-helmet'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import InlineEdit from '../InlineEdit/InlineEdit'
import { TabPanel, a11yProps } from '../TabPanel/TabPanel'
import '../InlineEdit/InlineEdit.css'
import EditQuizInfo from '../EditQuizInfo/EditQuizInfo'
import EditQuizConfigurations from '../EditQuizConfirgurations/EditQuizConfigurations'
import EditQuestions from '../EditQuestions/EditQuestions'
import Loader from '../Loader/Loader'
import {
  useQuizGetQueryById,
  useQuizQuestionGetQueryById,
  useQuizPatchById,
} from '../../Queries/QuizQuery'
import { getQuizUrl } from '../../constant'
import QuizNotFound from '../QuizNotFound/QuizNotFound'
import { useStyles } from './EditQuizMainStyles'
import ReviewQuiz from '../ReviewQuiz/ReviewQuiz'
import CommonSnackbar from '../CommonSnackbar/CommonSnackbar'
import { delay } from '../../utils'
import { hasUnsavedSettings, hasUnsavedInfo } from './unsavedSettings'

const DEFAULT_INSTRUCTIONS =
  'Please ensure you have a stable internet connection\nDo not open in Incognito mode, login may not work\nYou would be required to keep your camera on during the test\nDo not switch to any other tab/ window as it may lead to disqualification from the test\nAnswers selected are auto-saved\nTest would close exactly at the end time, submissions after that would not be allowed'

const EditQuizMain = () => {
  const { id } = useParams()
  const history = useHistory()
  const queryClient = useQueryClient()
  const email = localStorage.getItem('email')
  const [value, setValue] = React.useState(0)
  const [title, setTitle] = useState('')
  const [addQuestion, setAddQuestion] = useState(false)
  const [localQuestion, setLocalQuestion] = useState({})
  const [editQuestion, setEditQuestion] = useState(NaN)
  const [editViewQuestion, setEditViewQuestion] = useState({})
  const [textEditorQuestion, setTextEditorQuestion] = useState({
    question: '<p></p>',
  })
  const [quizNotFound, setQuizNotFound] = useState(false)
  const [isDraftLoading, setIsDraftLoading] = useState(false)
  const [isPublishLoading, setIsPublishLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [truthValue, setTruthValue] = useState(false)
  const [publishDialog, setPublishDialog] = useState(false)
  const [copied, setCopied] = useState(false)
  const [quizSaveButtonType, setQuizSaveButtonType] = useState(null)
  const [quizConfigCost, setQuizConfigCost] = useState(0)
  const [privateWithInvitees, setPrivateWithInvitees] = useState(false)
  const [codingQuestionSwitch, setCodingQuestionSwitch] = useState(false)
  // tab the user asked for while settings are unsaved, null when no popup is open
  const [pendingTab, setPendingTab] = useState(null)
  const [isSavingSettings, setIsSavingSettings] = useState(false)
  const [quizInfo, updateQuizInfo] = useState({
    description: null,
    instructions: DEFAULT_INSTRUCTIONS,
    startTime: null,
    endTime: null,
    duration: null,
    error: {
      emptyDescription: false,
      invalidDescription: false,
    },
  })

  const [quizSettings, updateQuizSettings] = useState({
    type: null,
    randomize: null,
    invitees: null,
    domain: null,
    result: false,
    emailDomainsCount: 0,
    proctored: null,
    error: {
      invalidInvitee: false,
    },
    permissions: null,
  })
  const [localQuiz, setLocalQuiz] = useState({
    info: {
      title: '',
      description: '',
      instructions: '',
      // status field must have field values "DRAFT","PUBLISHED","CLOSED","ENDED"
      status: '',
    },
    quizConfig: {
      isProctored: '',
      isRandomize: '',
      showResult: '',
      type: '',
    },
    invitees: [''],
    domainName: '',
    time: {
      start: '',
      end: null,
      duration: '',
    },
    maxMarks: '',
  })

  const [localQuizQuestion, setLocalQuizQuestion] = useState({
    questions: [],
  })
  const classes = useStyles({
    publish: localQuiz?.status === 'PUBLISHED',
  })
  const [invalidEmail, setInvalidEmail] = useState(false)
  const [invalidEmails, setInvalidEmails] = useState([])
  const [validationErrors, setValidationErrors] = useState({
    title: false,
    duration: false,
    startTime: false,
    endTime: false,
    description: false,
    instructions: false,
  })
  const [errors, setErrors] = useState({
    durationError: '',
    startTimeError: '',
    endTimeError: '',
    deleteSavedCodingQuestions: false,
  })
  const [editOngoing, setEditOngoing] = useState(false)

  const isQuizRunning = () =>
    localQuiz?.status === 'PUBLISHED' &&
    quizInfo?.startTime &&
    moment().isAfter(moment(quizInfo.startTime))

  const {
    data: quizObject,
    isLoading: isQuizLoading,
    refetch: refetchGetQueryById,
  } = useQuizGetQueryById(id, email, {
    staleTime: 0,
    retry: 0,
    onError: (err) => {
      if (
        (err.status === 404 && err.code === 'ENTITY_NOT_FOUND') ||
        (err.status === 400 && err.code === 'BAD_REQUEST')
      ) {
        setQuizNotFound(true)
      }
    },
  })

  const {
    data: quizQuestionObject,
    isLoading: isQuiQuestionLoading,
    isFetching: isQuizQuestionFetching,
    refetch: refetchGetQuizQuestionQueryById,
  } = useQuizQuestionGetQueryById(id, {
    staleTime: 0,
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    onError: (err) => {
      // A quiz with no questions yet returns 404 "Question doesn't Exist"
      // here, that's expected, not a sign the quiz is missing
      // Only the quiz GET call's onError should set quizNotFound
      if (err.status === 404 && err.code === 'ENTITY_NOT_FOUND') {
        setLocalQuizQuestion({ questions: [] })
        return
      }

      // Any other failure is a real problem fetching questions,-
      // -surface it instead of silently mislabeling the quiz
      setErrorMessage(err.message || 'Failed to load questions')
    },
    onSuccess: (successData) => {
      setLocalQuizQuestion(successData)
    },
  })

  const updateQuiz = useQuizPatchById(localQuiz?.id, {
    retry: false,
    onError: (err) => {
      setIsPublishLoading(false)
      setIsDraftLoading(false)
      setErrorMessage(err.message)
    },
    onSuccess: async () => {
      setIsPublishLoading(false)
      await delay(0.0001 * 1000)
      await queryClient.invalidateQueries('quizGetQueryById')
    },
  })

  useEffect(() => {
    if (quizQuestionObject && quizQuestionObject?.coding?.length > 0) {
      setCodingQuestionSwitch(true)
    }
  }, [quizQuestionObject])

  useEffect(() => {
    if (quizObject === undefined) return
    setLocalQuiz(quizObject)
    if (
      !quizInfo?.description ||
      !quizInfo?.instructions ||
      !quizInfo?.startTime
    ) {
      updateQuizInfo((prevQuizInfo) => {
        const updatedQuizInfo = JSON.parse(JSON.stringify(prevQuizInfo))
        updatedQuizInfo.description = updatedQuizInfo.description
          ? updatedQuizInfo.description
          : quizObject?.info?.description.trim()
        updatedQuizInfo.startTime = quizObject?.time?.start
        updatedQuizInfo.endTime = quizObject?.time?.end
        updatedQuizInfo.duration = quizObject?.time?.duration
        if (quizObject?.info?.instructions === '') {
          updatedQuizInfo.instructions = DEFAULT_INSTRUCTIONS
        } else {
          updatedQuizInfo.instructions = quizObject?.info?.instructions.trim()
        }
        return updatedQuizInfo
      })
    }
    if (
      !quizSettings.type ||
      !quizSettings.randomize ||
      !quizSettings.result ||
      !quizSettings.proctored
    ) {
      updateQuizSettings((prev) => {
        const updated = { ...prev }
        if (
          quizObject?.invitees === null &&
          quizObject?.quizConfig?.type === 'private'
        ) {
          updated.type = 'private'
        } else if (
          quizObject?.invitees !== null &&
          quizObject?.quizConfig?.type === 'private'
        ) {
          updated.type = 'private'
          setPrivateWithInvitees(true)
        } else {
          updated.type = quizObject?.quizConfig?.type
        }
        updated.randomize = quizObject?.quizConfig?.isRandomize
        updated.result = quizObject?.quizConfig?.showResult
        updated.proctored = quizObject?.quizConfig?.isProctored
        return updated
      })
    }
    if (quizInfo.startTime && quizInfo.endTime) {
      if (quizInfo.startTime >= quizInfo.endTime) {
        setErrors({
          ...errors,
          endTimeError: 'End time should be greater than start time',
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizObject, quizQuestionObject])

  const redirectPage = (e) => {
    e.preventDefault()
    e.returnValue = ''
  }

  useEffect(() => {
    window.addEventListener('beforeunload', redirectPage)

    return () => {
      window.removeEventListener('beforeunload', redirectPage)
    }
  }, [])
  useEffect(() => {
    if (updateQuiz?.isSuccess && quizSaveButtonType === 'save') {
      setIsDraftLoading(false)
      setTruthValue(true)
      setErrorMessage('Data saved successfully!')
    }
    if (updateQuiz?.isSuccess && quizSaveButtonType === 'publish') {
      setIsPublishLoading(false)
      setPublishDialog(true)
    }
  }, [quizSaveButtonType, updateQuiz?.isSuccess])

  const goToTab = (newValue) => {
    setValue(newValue)
    if (quizSettings?.type?.toLowerCase() !== 'private') {
      updateQuizSettings((prev) => ({ ...prev, invitees: null }))
    }
  }

  // the server checks the saved quiz type (e.g. coding questions need a saved private quiz),
  // and tabs only change the page, so unsaved changes must be saved or discarded before leaving
  const hasPendingSettings = () =>
    localQuiz?.isWriteAllowed &&
    localQuiz?.status !== 'CLOSED' &&
    localQuiz?.status !== 'ENDED' &&
    !isQuizRunning() &&
    (hasUnsavedSettings(quizObject, quizSettings) ||
      hasUnsavedInfo(
        quizObject,
        { ...quizInfo, title: localQuiz?.info?.title },
        DEFAULT_INSTRUCTIONS
      ))

  const handleChange = (event, newValue) => {
    if (newValue !== value && hasPendingSettings()) {
      setPendingTab(newValue)
      return
    }
    goToTab(newValue)
  }

  const handleSave = (isPublished, receivedFrom = '', saveOptions) => {
    const dummyLocalQuiz = JSON.parse(JSON.stringify(localQuiz))

    // sync quiz info and settings into the copy directly
    dummyLocalQuiz.info.description = quizInfo?.description?.trim()
    dummyLocalQuiz.info.instructions = quizInfo?.instructions?.trim()
    dummyLocalQuiz.time.start = quizInfo?.startTime
    dummyLocalQuiz.time.end = quizInfo?.endTime
    dummyLocalQuiz.time.duration = quizInfo?.duration
    dummyLocalQuiz.quizConfig.type = quizSettings.type
    dummyLocalQuiz.quizConfig.isRandomize = quizSettings.randomize
    dummyLocalQuiz.invitees =
      quizSettings.type === 'private' ? quizSettings.invitees : null
    dummyLocalQuiz.quizConfig.showResult = quizSettings.result
    dummyLocalQuiz.quizConfig.isProctored = quizSettings.proctored

    // remove server-only fields
    delete dummyLocalQuiz.createdAt
    delete dummyLocalQuiz.createdBy
    delete dummyLocalQuiz.info.slug
    delete dummyLocalQuiz.questions
    delete dummyLocalQuiz.counts
    delete dummyLocalQuiz.isClosed

    if (isPublished) dummyLocalQuiz.status = 'PUBLISHED'

    // convert times to unix seconds
    const startTime = dummyLocalQuiz.time.start ?? null
    const endTime = dummyLocalQuiz.time.end ?? null
    if (startTime)
      dummyLocalQuiz.time.start = Math.floor(
        new Date(startTime).getTime() / 1000
      )
    if (endTime)
      dummyLocalQuiz.time.end = Math.floor(new Date(endTime).getTime() / 1000)
    dummyLocalQuiz.time.duration = parseInt(dummyLocalQuiz.time.duration, 10)

    if (!dummyLocalQuiz.isWriteAllowed || dummyLocalQuiz.status === 'ENDED')
      return

    const isPast = startTime && moment(startTime).isBefore(moment())
    const isAlreadyPublished = localQuiz?.status === 'PUBLISHED'

    if (isPublished) {
      if (isPast && !isAlreadyPublished) {
        if (receivedFrom === 'save') {
          updateQuiz.mutate(dummyLocalQuiz, saveOptions)
        } else {
          setErrorMessage('Cannot publish: start time is in the past.')
        }
      } else {
        updateQuiz.mutate(dummyLocalQuiz, saveOptions)
      }
    } else {
      updateQuiz.mutate(dummyLocalQuiz, saveOptions)
    }
  }

  const handleTitle = (titleValue) => {
    const dummyQuiz = JSON.parse(JSON.stringify(localQuiz))
    setTitle(titleValue)
    dummyQuiz.info.title = titleValue
    setLocalQuiz(dummyQuiz)
  }
  const handleCloseSnackBar = () => {
    setErrorMessage('')
    setTimeout(() => setTruthValue(false), 1000)
  }

  const handleCloseDialog = () => {
    setPublishDialog(false)
    setQuizSaveButtonType('save')
  }

  const handlePublish = () => {
    if (value !== 3) {
      setValue(3)
      // Don't call handleSave yet, user needs to land on Review tab first
      return
    }

    setQuizSaveButtonType('publish')
    handleSave(true, 'publish')
  }

  const copy = () => {
    const el = document.createElement('input')
    el.value = `${getQuizUrl()}/quiz/${localQuiz?.info?.slug}`
    navigator.clipboard.writeText(el.value)
    setCopied(true)
  }

  const isPublishable = () => {
    if (quizSettings?.type === 'public' && localQuizQuestion?.coding)
      return false

    if (
      codingQuestionSwitch &&
      localQuizQuestion?.questionCount &&
      !localQuizQuestion?.questionCount[2]?.count
    )
      return false

    if (
      quizInfo?.startTime &&
      quizInfo?.endTime &&
      moment(quizInfo.startTime).isSameOrAfter(moment(quizInfo.endTime))
    )
      return false

    if (quizInfo?.startTime && moment().isAfter(moment(quizInfo.startTime)))
      return false

    return (
      !!quizInfo?.description?.trim() &&
      localQuizQuestion?.questions?.length > 0 &&
      !!localQuiz?.info?.title?.trim() &&
      !!quizInfo?.duration &&
      Number(quizInfo.duration) > 0
    )
  }

  const handleInvalidDuration = () => {
    if (
      Number.isNaN(Number(quizInfo?.duration)) ||
      Number(quizInfo?.duration) <= 0
    ) {
      setErrorMessage('Please enter valid Duration')
      return true // return flag so callers can bail
    }

    return false
  }

  const handleRedirectAfterPublish = () => {
    setPublishDialog(false)
    history.push('/')
  }

  useEffect(() => {
    if (quizSettings?.type === 'public') {
      setQuizConfigCost(0)
    } else if (quizSettings?.type === 'private') {
      setQuizConfigCost(1)
      if (quizSettings?.proctored && codingQuestionSwitch) setQuizConfigCost(7)
      else if (quizSettings?.proctored) setQuizConfigCost(5)
      else if (codingQuestionSwitch) setQuizConfigCost(3)
    }
  }, [quizSettings, codingQuestionSwitch])

  const handleBackButton = () => {
    if (value !== 0) handleChange(null, value - 1)
  }

  const stayOnTab = () => setPendingTab(null)

  const discardSettings = () => {
    const saved = quizObject.quizConfig

    updateQuizSettings((prev) => ({
      ...prev,
      type: saved.type,
      randomize: saved.isRandomize,
      result: saved.showResult,
      proctored: saved.isProctored,
    }))
    updateQuizInfo((prev) => ({
      ...prev,
      description: quizObject.info.description.trim(),
      instructions: quizObject.info.instructions.trim() || DEFAULT_INSTRUCTIONS,
      startTime: quizObject.time.start,
      endTime: quizObject.time.end,
      duration: quizObject.time.duration,
    }))
    setTitle('')
    setLocalQuiz((prev) => ({
      ...prev,
      info: { ...prev.info, title: quizObject.info.title },
    }))
    setErrors((prev) => ({ ...prev, startTimeError: '', endTimeError: '' }))
    setCodingQuestionSwitch(quizQuestionObject?.coding?.length > 0)
    goToTab(pendingTab)
    setPendingTab(null)
  }

  const saveSettingsAndContinue = () => {
    const tab = pendingTab

    setIsSavingSettings(true)
    handleSave(localQuiz?.status === 'PUBLISHED', '', {
      onSuccess: () => {
        setIsSavingSettings(false)
        setPendingTab(null)
        goToTab(tab)
      },
      onError: () => setIsSavingSettings(false),
    })
  }

  const handleNextButton = () => {
    if (!isQuizRunning()) handleSave(localQuiz?.status === 'PUBLISHED')
    if (value !== 3) setValue(value + 1)
  }

  const handleSaveAsDraft = () => {
    if (quizInfo?.description.trim() === '' && value !== 0) {
      return setErrorMessage('Please enter Description')
    }
    if (quizInfo?.instructions.trim() === '' && value !== 0) {
      return setErrorMessage('Instructions cannot be empty.')
    }
    if (
      codingQuestionSwitch &&
      value === 2 &&
      localQuizQuestion?.questionCount &&
      !localQuizQuestion?.questionCount[2]?.count
    ) {
      return setErrorMessage(
        'Please add Coding Question as it is enabled, Else disable Coding Question in Configurations tab'
      )
    }
    handleInvalidDuration()
    setQuizSaveButtonType('save')
    handleSave(false)
    return ''
  }

  const handlePublishButton = () => {
    if (handleInvalidDuration()) return

    if (
      codingQuestionSwitch &&
      localQuizQuestion?.questionCount &&
      !localQuizQuestion?.questionCount[2]?.count
    ) {
      setErrorMessage(
        'Please add Coding Question as it is enabled, or disable it in Configurations tab'
      )
      return
    }

    if (quizSettings?.type === 'private') {
      if (
        quizSettings?.invitees?.length >= 1 ||
        quizSettings?.domain?.length >= 1
      ) {
        setIsPublishLoading(true)
        handlePublish()
      } else {
        setErrorMessage('Please add invitees or a domain for a private quiz.')
      }
    } else {
      setIsPublishLoading(true)
      handlePublish()
    }
  }

  const nextOnClick = () => {
    setQuizSaveButtonType('')
    // All saving of each tab happens through next button
  }

  if (quizNotFound) {
    return <QuizNotFound reason="Quiz not found" />
  }

  return (
    <>
      <Helmet>
        <title>{localQuiz?.info?.title}</title>
      </Helmet>
      {isQuizLoading || isQuiQuestionLoading ? (
        <div className={classes.loader}>
          <Loader size="8rem" />
        </div>
      ) : (
        <div className={classes.root}>
          <div className={classes.editQuizHeader}>
            <Container className={classes.container}>
              <Grid className={classes.titleAndCreditsWrapper}>
                <div className={classes.quizTitle}>
                  <InlineEdit
                    text={title === '' ? localQuiz?.info?.title.trim() : title}
                    onSetText={(text) => handleTitle(text)}
                    quizStartTime={quizInfo.startTime}
                    isPublished={localQuiz?.status === 'PUBLISHED'}
                    isClosed={
                      localQuiz?.status === 'CLOSED' ||
                      localQuiz?.status === 'ENDED' ||
                      !localQuiz?.isWriteAllowed
                    }
                    isWriteAllowed={localQuiz?.isWriteAllowed}
                    setErrorMessage={setErrorMessage}
                  />
                </div>
                <div className={classes.linkAndCreditsContainer}>
                  {localQuiz?.status === 'PUBLISHED' ? (
                    <Grid
                      item
                      container
                      direction="row"
                      alignItems="center"
                      justifyContent="flex-end"
                      className={classes.buttonWrapper}
                    >
                      <Button
                        disabled={
                          localQuiz?.status === 'CLOSED' ||
                          localQuiz?.status === 'ENDED' ||
                          !localQuiz?.isWriteAllowed
                        }
                        onClick={copy}
                        variant="outlined"
                        className={classes.copyUrlButton}
                      >
                        {!copied ? 'Copy quiz link' : 'Copied!'}
                      </Button>
                    </Grid>
                  ) : (
                    ''
                  )}
                  <Grid className={classes.quizConfigCostWrapper}>
                    <div className={classes.quizConfigCostDiv}>
                      <Typography className={classes.creditMessage}>
                        Cost Per Attempt
                      </Typography>
                      <Typography className={classes.creditSubMessage}>
                        Amount chargeable
                      </Typography>
                    </div>
                    <div className={classes.creditsContainer}>
                      <Typography className={classes.credits}>
                        {quizConfigCost}C
                      </Typography>
                    </div>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={12}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                  indicatorColor="secondary"
                  className={classes.tabs}
                >
                  <Tab
                    classes={{
                      wrapper: classes.iconLabelWrapper,
                      labelIcon: classes.labelIcon,
                    }}
                    label="Config"
                    icon={
                      (validationErrors?.duration ||
                        validationErrors?.startTime ||
                        validationErrors?.endTime) && (
                        <CancelIcon
                          style={{
                            color: 'red',
                            marginBottom: '0px',
                            marginRight: '4px',
                          }}
                        />
                      )
                    }
                    onClick={nextOnClick}
                    {...a11yProps(0)}
                    className={classes.tab}
                  />
                  <Tab
                    classes={{
                      wrapper: classes.iconLabelWrapper,
                      labelIcon: classes.labelIcon,
                    }}
                    label="Info"
                    icon={
                      (validationErrors?.description ||
                        validationErrors?.instructions) && (
                        <CancelIcon
                          style={{
                            color: 'red',
                            marginBottom: '0px',
                            marginRight: '4px',
                          }}
                        />
                      )
                    }
                    onClick={nextOnClick}
                    {...a11yProps(1)}
                    className={classes.tab}
                  />
                  <Tab
                    label="Questions"
                    onClick={nextOnClick}
                    {...a11yProps(2)}
                    className={classes.tab}
                  />
                  <Tab
                    label="Review"
                    onClick={nextOnClick}
                    {...a11yProps(3)}
                    className={classes.tab}
                  />
                </Tabs>
              </Grid>
            </Container>
          </div>
          <div className={classes.editQuizBody}>
            <Container className={classes.container}>
              <TabPanel value={value} index={0}>
                <EditQuizConfigurations
                  quizId={quizObject?.id}
                  quizObject={quizObject}
                  questionCount={localQuizQuestion?.questionCount}
                  questions={localQuizQuestion?.questions}
                  quizInfo={quizInfo}
                  updateQuizInfo={updateQuizInfo}
                  isPublished={localQuiz?.status === 'PUBLISHED'}
                  isClosed={
                    localQuiz?.status === 'CLOSED' ||
                    localQuiz?.status === 'ENDED' ||
                    !localQuiz?.isWriteAllowed
                  }
                  quizSettings={quizSettings}
                  updateQuizSettings={updateQuizSettings}
                  invalidEmail={invalidEmail}
                  setInvalidEmail={setInvalidEmail}
                  invalidEmails={invalidEmails}
                  setInvalidEmails={setInvalidEmails}
                  privateWithInvitees={privateWithInvitees}
                  setPrivateWithInvitees={setPrivateWithInvitees}
                  codingQuestionSwitch={codingQuestionSwitch}
                  setCodingQuestionSwitch={setCodingQuestionSwitch}
                  errors={errors}
                  setErrors={setErrors}
                  isWriteAllowed={localQuiz?.isWriteAllowed}
                />
              </TabPanel>
            </Container>
            <Container className={classes.container}>
              <TabPanel value={value} index={1}>
                <EditQuizInfo
                  quizInfo={quizInfo}
                  updateQuizInfo={updateQuizInfo}
                  isPublished={localQuiz?.status === 'PUBLISHED'}
                  isClosed={
                    localQuiz?.status === 'CLOSED' || !localQuiz?.isWriteAllowed
                  }
                  isWriteAllowed={localQuiz?.isWriteAllowed}
                  setErrorMessage={setErrorMessage}
                />
              </TabPanel>
            </Container>
            <TabPanel value={value} index={2}>
              <EditQuestions
                quizInfo={quizInfo}
                quizObject={quizObject}
                quizType={quizSettings?.type}
                questions={localQuizQuestion?.questions}
                quizId={localQuiz?.id}
                quizStartTime={quizInfo.startTime}
                isPublished={localQuiz?.status === 'PUBLISHED'}
                isClosed={
                  localQuiz?.status === 'CLOSED' ||
                  localQuiz?.status === 'ENDED' ||
                  !localQuiz?.isWriteAllowed
                }
                codingQuestionSwitch={codingQuestionSwitch}
                setCodingQuestionSwitch={setCodingQuestionSwitch}
                refetchGetQueryById={refetchGetQueryById}
                refetchGetQuizQuestionQueryById={
                  refetchGetQuizQuestionQueryById
                }
                isQuiQuestionLoading={isQuiQuestionLoading}
                isQuizQuestionFetching={isQuizQuestionFetching}
                isWriteAllowed={localQuiz?.isWriteAllowed}
                setTextEditorQuestion={setTextEditorQuestion}
                textEditorQuestion={textEditorQuestion}
                setLocalQuestion={setLocalQuestion}
                localQuestion={localQuestion}
                setAddQuestion={setAddQuestion}
                addQuestion={addQuestion}
                setEditViewQuestion={setEditViewQuestion}
                editViewQuestion={editViewQuestion}
                editQuestion={editQuestion}
                setEditQuestion={setEditQuestion}
                editOngoing={editOngoing}
                setEditOngoing={setEditOngoing}
              />
            </TabPanel>
            <Container className={classes.container}>
              <TabPanel value={value} index={3}>
                <ReviewQuiz
                  isPublishLoading={isPublishLoading}
                  isDraftLoading={isDraftLoading}
                  setIsDraftLoading={setIsDraftLoading}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  updateQuiz={updateQuiz}
                  handleSaveAsDraft={handleSaveAsDraft}
                  isPublishable={isPublishable}
                  handlePublishButton={handlePublishButton}
                  setQuizSaveButtonType={setQuizSaveButtonType}
                  handleSave={handleSave}
                  localQuiz={localQuiz}
                  quizInfo={quizInfo}
                  quizSettings={quizSettings}
                  codingQuestionSwitch={codingQuestionSwitch}
                  questions={localQuizQuestion?.questions}
                  localQuizQuestion={localQuizQuestion}
                  isWriteAllowed={localQuiz?.isWriteAllowed}
                />
              </TabPanel>
            </Container>
          </div>

          {/* Edit Quiz Footer */}
          <div
            className={classes.editQuizFooter}
            style={{ backgroundColor: 'white' }}
          >
            <Container className={classes.container}>
              <Grid
                item
                container
                xs={12}
                direction="row"
                alignItems="center"
                className={classes.editQuizFooterButtons}
              >
                <Button
                  className={classes.publishButton}
                  onClick={() => handleBackButton()}
                  disabled={value === 0}
                  startIcon={<NavigateBeforeIcon />}
                >
                  Back
                </Button>
                <Button
                  className={classes.publishButton}
                  onClick={() => handleNextButton()}
                  disabled={value === 3}
                  endIcon={<NavigateNextIcon />}
                >
                  Next
                </Button>
              </Grid>
            </Container>
          </div>
        </div>
      )}
      <CommonSnackbar
        open={errorMessage !== ''}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
        severity={truthValue ? 'success' : 'error'}
        message={errorMessage}
      />
      <Dialog
        open={pendingTab !== null}
        onClose={isSavingSettings ? undefined : stayOnTab}
        aria-labelledby="unsaved-settings-title"
        aria-describedby="unsaved-settings-description"
      >
        <DialogTitle id="unsaved-settings-title">Unsaved changes</DialogTitle>
        <DialogContent>
          <div id="unsaved-settings-description">
            You have unsaved changes. Please save them first, otherwise they
            will be lost.
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={stayOnTab} disabled={isSavingSettings}>
            Stay
          </Button>
          <Button onClick={discardSettings} disabled={isSavingSettings}>
            Discard changes
          </Button>
          <Button
            onClick={saveSettingsAndContinue}
            color="primary"
            variant="contained"
            disabled={isSavingSettings}
          >
            {isSavingSettings ? 'Saving...' : 'Save and continue'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={publishDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <div id="alert-dialog-description">
            Quiz has been published successfully. <br />
            <br />
            <Chip
              className={classes.alertCopyLinkButton}
              onClick={copy}
              label={!copied ? 'Copy quiz link' : 'Copied!'}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRedirectAfterPublish} autoFocus>
            ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default EditQuizMain
